import { ProgramNames, PROVIDER_TYPES } from '../../../models'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ConsentText } from '../messages'
import { ProgramConfig } from '../types'

const DIRECT_ACCESS_PROGRAM_DEFAULTS = {
  customerPropertyId: ProgramCustomerPropertyId.directAccessTherapy,
  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  selfPayEligible: false,
  isDAEngageProgram: true,
  consents: [
    {
      consentText: ConsentText.therapyConsent,
      consentUrl: 'https://www.lyrahealth.com/lt-agreement',
      showConsentIf: () => true,
    },
  ],
  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },
  noteContentMetadataName: {
    INITIAL_NOTE: 'daInitialNote',
    SESSION_NOTE: 'daSessionNote',
    GENERAL_NOTE: 'daGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
  },
} satisfies Partial<ProgramConfig>

export const DIRECT_ACCESS_COUPLES_THERAPY_PROGRAM = {
  ...DIRECT_ACCESS_PROGRAM_DEFAULTS,
  programName: ProgramNames.DirectAccessCouplesTherapy,
  blendedCareProgramId: '690f8981-70c3-4714-b667-464da34cd1c2',

  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  associatedProviderModalities: ['couples'],

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.COUPLES_THERAPY],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.couples,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: false,
  },

  canRescheduleAppointment: true,
} satisfies ProgramConfig

export const DIRECT_ACCESS_INDIVIDUAL_THERAPY_PROGRAM = {
  ...DIRECT_ACCESS_PROGRAM_DEFAULTS,
  programName: ProgramNames.DirectAccessIndividualTherapy,
  blendedCareProgramId: 'affa3537-78a4-4abf-b330-b7abc1a5740b',

  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  associatedProviderModalities: ['individual'],

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.INDIVIDUAL_THERAPY],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: false,
  },

  canRescheduleAppointment: true,
} satisfies ProgramConfig

export const DIRECT_ACCESS_FAMILY_THERAPY_PROGRAM = {
  ...DIRECT_ACCESS_PROGRAM_DEFAULTS,
  programName: ProgramNames.DirectAccessFamilyTherapy,
  blendedCareProgramId: '9cc004d9-614c-4a95-8176-d1ac89e5628a',

  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  associatedProviderModalities: ['family'],

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.FAMILY_THERAPY],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.family,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: false,
  },

  canRescheduleAppointment: true,
} satisfies ProgramConfig

export const DIRECT_ACCESS_INDIVIDUAL_ADOLESCENT_THERAPY_PROGRAM = {
  ...DIRECT_ACCESS_PROGRAM_DEFAULTS,
  programName: ProgramNames.DirectAccessIndividualAdolescentTherapy,
  blendedCareProgramId: 'c7034a1f-f506-4349-afab-69e173052238',
  isDAMinorProgram: true,

  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  associatedProviderModalities: ['individual'],

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: false,
  },

  canRescheduleAppointment: true,
} satisfies ProgramConfig

export const DIRECT_ACCESS_INDIVIDUAL_CHILD_THERAPY_PROGRAM = {
  ...DIRECT_ACCESS_PROGRAM_DEFAULTS,
  programName: ProgramNames.DirectAccessIndividualChildTherapy,
  blendedCareProgramId: 'd125cead-10a1-4d90-9f9f-457ca3490e91',
  isDAMinorProgram: true,

  associatedProviderTypes: [PROVIDER_TYPES.THERAPIST.lyraType],
  associatedProviderModalities: ['individual'],

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.therapy,
        partner: PROGRAM_TAXONOMY.partner.directAccess,
        offering: PROGRAM_TAXONOMY.offering.default,
      },
    ],
    isFullTreatmentOption: false,
  },

  canRescheduleAppointment: true,
} satisfies ProgramConfig
